export function currencyByLocation(setCurrencySymbol) {
  return (newLocation) => {
    switch (newLocation) {
      case "us":
        setCurrencySymbol("$");
        break;
      case "eu":
        setCurrencySymbol("€");
        break;
      case "uk":
        setCurrencySymbol("£");
        break;
      case "il":
        setCurrencySymbol("₪");
        break;
      default:
        setCurrencySymbol("$");
    }
  };
}
